import { render, staticRenderFns } from "./backgroundTaskManagement.vue?vue&type=template&id=35c8f19c&scoped=true"
import script from "./backgroundTaskManagement.vue?vue&type=script&lang=js"
export * from "./backgroundTaskManagement.vue?vue&type=script&lang=js"
import style0 from "./backgroundTaskManagement.vue?vue&type=style&index=0&id=35c8f19c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8f19c",
  null
  
)

export default component.exports